module.exports = __webpack_public_path__ + "static/img/helh34.8dfc1d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthycockpit/helh34.png
// module id = qqeW
// module chunks = 5